/* eslint-disable max-len, key-spacing */
/*
* @AD_UNITS
* Compactly expressed prebid units
* shape: ['adform:mid', 'rubicon:zoneId', 'appnexus:placementId', 'msupply:placementId', 'omgz:mid', 'IUM:mid', 'Concept:mid', 'Criteo:ZoneId', 'Publicis:mid']'
*/

export const bidders = {
  small: {
    // On the front page in small breakpoint, we will be using topbanner-2 as topbanner-1. topbanner-1 will not be used.
    // Thus, we will blank out the topbanner-1 for the front page, and pass identifiers to all remaining topbanners.
    Forsiden_Forside_Topbanner_1: [],

    Forside_Rectangle_1:       ['683198', '1420022', '17049667', '17085955', '714888', '795718', '806326', '1522547', '897884'],
    Forside_Rectangle_2:       ['683200', '1420026', '17049717', '17085956', '714889', '795719', '806327', '1522546', '897885'],
    Forside_Topbanner:         ['683205', '1420028', '17049719', '17085963', '714890', '795720', '806344', '1522541', '897886'],
    Forside_Wide_1:            ['683206', '1420030', '17049723', '17085965', '714891', '795721', '806345', '1522540', '897887'],
    Rectangle_1:               ['683207', '1420034', '17049724', '17085957', '714892', '795722', '806348', '1522545', '897888'],
    Rectangle_2:               ['683208', '1420036', '17049726', '17085959', '714893', '795723', '806350', '1522544', '897889'],
    Rectangle_4:               ['683218', '1389722', '16685541', '16700020', '702034', '795724', '806349', '1522543', '897890'],
    Topbanner_1:               ['683221', '1420040', '17049728', '17085967', '714894', '795725', '806351', '1522539', '897891'],
    Wide_1:                    ['683222', '1420042', '17049729', '17085970', '714895', '795726', '806355', '1522538', '897892'],
    Wide_2:                    ['686719', '1139402', '14756224', '16699982', '702031', '795727', '806354', '1522537', '897893'],
    Wide_3:                    ['686720', '1389718', '16685530', '16699984', '702033', '795728', '806353', '1522536', '897894'],
    Wide_4:                    ['817943', null, '19159834', '19220185', '818300', '795730', '806352', '1522535', '897895'],
    // Interscroller will be parsed as a twin unit, see http://prebid.org/dev-docs/adunit-reference.html#twin-adunit-codes
    Interscroller:             ['809959', '1734516', '19159835', '19222042', '801734', '795746', '833210', '1522542', '897896'],
  },
  medium: {
    Forside_Rectangle_1:       ['620835', '1139344', '14747007', '15343521', '639813', '795731', '806313', '1522532', '897870'],
    Forside_Rectangle_2:       ['620836', '1139352', '14756000', '15343522', '639814', '795732', '806315', '1522531', '897871'],
    Forside_Rectangle_3:       ['620837', '1139362', '14756053', '15343523', '639815', '795733', '806314', '1522530', '897872'],
    Forside_Skyscraperleft_1:  ['631666', '1139368', '14756088', '15343530', '639816', '795734', '806316', '1522527', '897873'],
    Forside_Skyscraperright_1: ['631666', '1139368', '14756088', '15343530', '639816', '795734', '806316', '1522527', '897873'],
    Forside_Topbanner_1:       ['620841', '1138750', '14756100', '15343532', '639817', '795735', '806317', '1522551', '897880'],
    Forside_Wide_1:            ['620855', '1139374', '14756105', '15343538', '639818', '795736', '806318', '1522553', '897874'],
    Rectangle_1:               ['620862', '1139378', '14756205', '15343527', '639819', '795738', '806319', '1522529', '897876'],
    Rectangle_2:               ['620868', '1139380', '14756207', '15343528', '639820', '795739', '806320', '1522533', '897877'],
    Rectangle_3:               ['620869', '1139382', '14756217', '15343529', '639821', '795740', '806321', '1522534', '897878'],
    Skyscraperleft_1:          ['631667', '1139384', '14756220', '15343531', '639822', '795741', '806322', '1522528', '897879'],
    Skyscraperright_1:         ['631667', '1139384', '14756220', '15343531', '639822', '795741', '806322', '1522528', '897879'],
    Topbanner_1:               ['620900', '1139388', '14756222', '15343534', '639823', '795742', '806323', '1522550', '897880'],
    Wide_1:                    ['620902', '1139392', '14756223', '15343540', '639824', '795743', '806324', '1522552', '897881'],
    Wide_4:                    ['817941', null, '19159825', '19220186', '818301', '795744', '806325', '1522549', '897882'],

    // Wallpaper will be parsed as a twin unit, see http://prebid.org/dev-docs/adunit-reference.html#twin-adunit-codes
    Wallpaper: ['817942', '1734518', '19159832', '19222031', '801735', '818052', '833206', '1522548', '897883'],
  },
};

export const twinBidders = {
  small: {
    Forside_Rectangle_2: 'Interscroller',
    Rectangle_2: 'Interscroller',
    Forside_Rectangle_4: 'Interscroller',
    Rectangle_4: 'Interscroller',
  },
  medium: {
    Forside_Topbanner_1: 'Wallpaper',
    Topbanner_1: 'Wallpaper',
  },
};

// Shape: ['adform:mid', 'omgz:mid']
export const videoBidders = {
  Video_1: ['934560'], // Video_1: ['934560', '65594'],
};
